module.exports = __webpack_public_path__ + "static/media/placeholder.99015d80.svg";